export enum DateUnitEnum {
  Days = 'Days',
  Weeks = 'Weeks',
  Months = 'Months',
  Years = 'Years'
}

export const SmallSizeList = ['B', 'Kb', 'Mb'] as const;
export type SmallSize = typeof SmallSizeList[number];
